import { useEffect } from 'react';

import { useCollectionManagementStore, useTaskFrameStore } from '@/store';
import type { FrameData } from '@/type';

export const useFrameSetMetaData = (frameDetail?: FrameData) => {
  const { readFile } = useCollectionManagementStore();
  const { setMetaData } = useTaskFrameStore();

  useEffect(() => {
    const metaPath = frameDetail?.metaPath;

    if (!metaPath) return;

    readFile({ key: metaPath })
      .then(res => res.body)
      .then(value =>
        value ? JSON.parse(new TextDecoder().decode(value)) : null,
      )
      .then(value => {
        setMetaData(value);
      })
      .catch(err => {
        console.group('[useFrameMetaData] error');
        console.warn(err);
        console.groupEnd();
      });
  }, [frameDetail?.metaPath]);
};
